export function formatDate(strDate: string) {
	return new Date(strDate).toLocaleDateString();
}
